import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryDetailPage from '../../containers/accessory-detail-page';

import Header from '../../blocks/header';
import SubNavigation from '../../blocks/sub-navigation';
import HeroCarousel from '../../blocks/hero-carousel';
import HeroVideo from '../../blocks/hero-video';
import HeroImage from '../../blocks/hero-image';
import SocialIconsContainerBlock from '../../containers/social-icons-container-block';
import SubFooterNavigation from '../../blocks/sub-footer-navigation';
import FooterNavigation from '../../containers/footer-navigation';
import CtaNavi from '../../containers/html';
import AnchorNavi from '../../containers/html';
import CookieEditor from '../../containers/html';
import FullWidth from '../../blocks/full-width';
import ExteriorView from '../../blocks/exterior-view';
import PhotoInfo from '../../containers/photo-info';
import TabNavigation from '../../containers/tab-navigation';
import SpecComparison from '../../blocks/spec-comparison';
import EcoTax from '../../containers/eco-tax';
import AccessoryDetailContent from '../../containers/accessory-detail-content';

const AccessoryDetailPageBlock = props => <AccessoryDetailPage {...props} />;
AccessoryDetailPageBlock.displayName = 'AccessoryDetailPage';

export default withDynamicComponents({
  componentWhitelist: [
    Header,
    SubNavigation,
    HeroCarousel,
    HeroVideo,
    HeroImage,
    SocialIconsContainerBlock,
    SubFooterNavigation,
    FooterNavigation,
    CtaNavi,
    AnchorNavi,
    CookieEditor,
    FullWidth,
    PhotoInfo,
    ExteriorView,
    TabNavigation,
    SpecComparison,
    EcoTax,
    AccessoryDetailContent,
  ],
  mapInputToOutput: [
    ['header', 'header'],
    ['upperPageNavigation', 'upperPageNavigation'],
    ['hero', 'hero'],
    ['components', 'children'],
    ['lowerPageNavigation', 'lowerPageNavigation'],
    ['footer', 'footer'],
    ['ctaNavi', 'ctaNavi'],
    ['anchorNavi', 'anchorNavi'],
    ['cookieEditor', 'cookieEditor'],
  ],
})(AccessoryDetailPageBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-detail-page/index.jsx